// TODO: Проверить, что нужно, а что нет
import 'inputmask/dist/inputmask/dependencyLibs/inputmask.dependencyLib';
window.Inputmask = require('inputmask/dist/inputmask/inputmask');
import Inputmask from 'inputmask/dist/inputmask/inputmask'
import 'inputmask/dist/inputmask/inputmask.phone.extensions';
import 'inputmask/dist/inputmask/phone-codes/phone';
import 'inputmask/dist/inputmask/jquery.inputmask';


(function ($, document, window) {
    $(document).ready(function(){
        $('[type=tel]').inputmask({
            mask: "+7 (999) 999-99-99",
        });
    });
})(jQuery, document, window);